import styles from '../css/XPProgressBar.module.css';

const XPProgressBar = ({ xpData, isLoading, isError }) => {
  // Skeleton — shown while loading or on error (bar is always present)
  if (isLoading || isError || !xpData) {
    return (
      <div className={styles.xpBar}>
        <div className={styles.header}>
          <div className={`${styles.skeletonText} ${styles.skeletonLevel}`} />
          <div className={`${styles.skeletonText} ${styles.skeletonFraction}`} />
        </div>
        <div className={styles.track}>
          <div className={styles.skeletonFill} />
        </div>
        <div className={`${styles.skeletonText} ${styles.skeletonTotal}`} />
      </div>
    );
  }

  const { level, xp_into_level, xp_needed, progress_pct, total_xp } = xpData;

  return (
    <div className={styles.xpBar}>
      <div className={styles.header}>
        <span className={styles.levelBadge}>Уровень {level}</span>
        <span className={styles.xpFraction}>{xp_into_level} / {xp_needed} XP</span>
      </div>
      <div className={styles.track}>
        <div
          className={styles.fill}
          style={{ width: `${Math.max(progress_pct, 0)}%` }}
          role="progressbar"
          aria-valuenow={progress_pct}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
      <span className={styles.totalXp}>Всего XP: {total_xp}</span>
    </div>
  );
};

export default XPProgressBar;
